(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'brandIcon',
            [
                'CHROME',
                BrandIconFactory
            ]
        );

    // Factory Method
    function BrandIconFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            template: '<span><a href="#!/landing/home"><img class="brand-icon" src="assets/image/brand/Sinewav3.png"></a></span>'
        };

    }
})();